import React from "react";
import classes from "./FullLoading.module.css";

const FullLoading = () => {
  return <div className={classes.progress}></div>;
};

export default FullLoading;
